import { getAutomationDataAttr } from "@/utils/automationUtils";

type PhotoPreviewProps = {
  fileName: Nullable<string>;
  previewUrl: Nullable<string>;
};

export function PhotoPreview({ fileName, previewUrl }: PhotoPreviewProps) {
  if (!previewUrl || !fileName) return null;

  return (
    <div className="tw:bg-gray-50 tw:overflow-hidden tw:rounded-lg tw:border tw:border-stroke-quaternary">
      <img
        alt={`Preview of ${fileName}`}
        className="tw:h-auto tw:w-full tw:object-contain"
        data-testid="previewImg"
        src={previewUrl}
        {...getAutomationDataAttr("photo-id-preview-image")}
      />
    </div>
  );
}
